import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PersianTitlesService {
  constructor() {}

  Items = {
    SystemName: 'مدرسه مدیریتی افرا',
    Row: 'ردیف',
    Yes: 'بله',
    No: 'خیر',
    Title: 'عنوان',
    Titles: 'عنوان‌ها',
    Date: 'تاریخ',
    Save: 'ذخیره',
    Submit: 'ثبت و ارسال',
    BasicInfo: 'اطلاعات پایه',
    FirstName: 'نام',
    LastName: 'نام خانوادگی',
    FullName: 'نام و نام خانوادگی',
    AboutMe: 'درباره من',
    Avatar: 'عکس پروفایل',
    Email: 'ایمیل',
    State: 'وضعیت',
    Index: 'ردیف',
    Description: 'توضیحات',
    System: 'سیستم',
    Type: 'نوع',
    User: 'کاربر',
    Username: 'نام کاربری',
    ImpersonateUsername: 'نام کاربری جایگزین',
    Password: 'رمز عبور',
    FileName: 'نام فایل',
    CreatedOn: 'تاریخ ایجاد',
    CreatedTime: 'ساعت ایجاد',
    CreatedBy: 'ایجاد کننده',
    LastModifier: 'آخرین ویرایش کننده',
    Login: 'ورود',
    Logout: 'خروج',
    CompanyName: 'نام شرکت',
    CompanyInformation: 'اطلاعات شرکت',
    Province: 'استان',
    City: 'شهر',
    ID: 'شناسه',
    IsActive: 'فعال؟',
    Edit: 'ویرایش',
    Activate: 'فعال کردن',
    Deactivate: 'غیرفعال کردن',
    Active: 'فعال',
    Inactive: 'غیرفعال',
    Unknown: 'نامشخص',
    Detail: 'جزئیات',
    UserManagement: 'مدیریت کاربران',
    UserList: 'فهرست کاربران',
    HasAccess: 'دسترسی ورود؟',
    UserProperty: 'مشخصات کاربر',
    Permission: 'دسترسی',
    Permissions: 'دسترسی‌ها',
    View: 'مشاهده',
    Change: 'تغییر',
    Delete: 'حذف',
    New: 'جدید',
    Add: 'افزودن',
    Refresh: 'همگام سازی',
    Cancel: 'انصراف',
    Return: 'بازگشت',
    Mobile: 'شماره تلفن همراه',
    LinkedinAddress: 'آدرس لینکدین',
    CooperationType: 'نوع همکاری',
    ProfilePicture: 'تصویر پروفایل',
    ChoosePicture: 'انتخاب تصویر',
    ChangeMobile: 'تغییر شماره تلفن همراه',
    GetOTP: 'دریافت پیامک کد ورود یکبارمصرف',
    GetOTPAgain: 'دریافت مجدد پیامک کد ورود یکبارمصرف',
    OTP: 'کد یکبارمصرف',
    LeftTime: 'زمان باقیمانده',
    Second: 'ثانیه',
    Profile: 'پروفایل',
    Workshops: 'کارگاه‌های آموزشی',
    Charity: 'موسسه نیکوکاری',
    LastEducationDegree: 'آخرین مدرک تحصیلی',
    EducationField: 'رشته تحصیلی',
    Position: 'سمت سازمانی',
    MyUserInformation: 'اطلاعات کاربری من',
    MyTrainingHistory: 'سابقه آموزشی من',
    MyPastworkshops: 'کارگاه‌های سپری شده من',
    MyWorkshops: 'کارگاه‌های ثبت‌نام شده من',
    MyUpcomingWorkshops: 'کارگاه‌های پیش‌روی من',
    MyWorkshopRegistrationRequests: 'درخواست‌های ثبت‌نام من',
    Finished: 'پایان یافته',
    InProgress: 'برنامه‌ریزی شده',
    Teacher: 'مدرس',
    HoldingDate: 'تاریخ برگزاری',
    HoldingType: 'شیوه اجرا',
    Location: 'محل برگزاری',
    RegistrationStatus: 'وضعیت ثبت‌نام',
    Register: 'ثبت‌نام',
    Registered: 'ثبت‌نام شده',
    RegisteredAndApproved: 'ثبت‌نام شده و تایید شده',
    RegisteredAndRejected: 'ثبت‌نام شده و رد شده',
    RegisteredAndPending: 'ثبت‌نام شده (در حال بررسی)',
    DaysLeft: 'روز دیگر',
    RequestDate: 'تاریخ درخواست',
    AttendanceType: 'نوع حضور',
    InformWay: 'نحوه آشنایی با کارگاه',
    HomePage: 'صفحه اصلی',
    Clear: 'پاک کردن',
    WorkshopsVideo: 'ویدیو کارگاه‌های آموزشی',
    Obligatory: 'موظف',
    Volunteer: 'داوطلب',
    addToGoogleCalendar: 'اضافه کردن به تقویم',
    CurrentWorkshops: 'کارگاه‌های آموزشی جاری',
    HeldWorkshops: 'کارگاه‌های آموزشی گذشته',
    preRegister: 'پیش ثبت‌نام',
    SearchBoxHeader: 'جستجو و فیلتر',
    SuggestionsAndCriticisms: 'انتقادها و پیشنهادها',
    subject: 'موضوع',
    messageText: 'متن پیام',
    preRegistered: 'پیش ثبت‌نام شده',
    ProfileEdit: 'ویرایش اطلاعات کاربری من',
  };

  Phrases = {
    UserUnauthorized: 'نام کاربری یا کلمه عبور اشتباه است.',
    TableIsEmpty: 'فهرست خالی است.',
    SaveSuccessfully: 'اطلاعات با موفقیت ذخیره شد.',
    SaveError: 'ذخیره اطلاعات با خطا متوقف شد.',
    Unauthorized: 'شما به این صفحه دسترسی ندارید.',
    DeleteConfirm: 'از حذف این مورد مطمئن هستید؟',
    ConnectionError: 'ارتباط با سرور امکانپذیر نیست.',
    UnknownError: 'خطایی رخ داده است.',
    RefreshSuccessfully: 'همگام سازی با موفقیت انجام شد.',
    RefreshError: 'همگام سازی با خطا متوقف شد.',
    ChooseACooperationType: 'یک نوع همکاری انتخاب کنید...',
    ChooseAPosition: 'یک سمت سازمانی انتخاب کنید...',
    ChooseACharity: 'یک موسسه نیکوکاری انتخاب کنید...',
    ChooseAEducationDegree: 'یک مدرک تحصیلی انتخاب کنید...',
    ChooseASubject: 'یک موضوع انتخاب کنید...',
    WorkshopRegisterSuccessfully:
      'ثبت نام شما انجام شد. منتظر تایید نهایی ثبت‌نام‌تان توسط مدیرعامل/رابط موسسه خود باشید. نتیجه تایید یا رد ثبت‌نام، برای شما در قالب پیامک اطلاع‌رسانی می‌شود.',
    WorkshopRegistrationRegisteredAndApprovedSuccessfully:
      'درخواست ثبت‌نام شما با موفقیت ثبت و تایید شد.',
    WorkshopRegistrationRegisteredAndPendedSuccessfully:
      'درخواست ثبت‌نام شما با موفقیت ثبت شد و جهت بررسی به مدیرعامل/رابط آموزشی موسسه نیکوکاری شما ارسال شد. نتیجه تایید یا رد ثبت‌نام، برای شما در قالب پیامک اطلاع‌رسانی می‌شود.',
    WorkshopRegisterError: 'ثبت نام با خطا متوقف شد.',
    ProfileApprovalRequired:
      'لطفا ابتدا اطلاعات کاربری خود را کامل و تایید کنید.',
    RegisterPrompt:
      'از ثبت نام در این کارگاه مطمئن هستم و با توجه به ظرفیت محدود کارگاه، متعهد می‌شوم در کارگاه حضور یابم.',
    FormValueError: 'مقادیر فرم نامعتبر هستند.',
    EnterYourQuestions:
      'لطفا در صورت تمایل سوالات موردنظر خود را در اینجا بنویسید:',
    ListIsEmpty: 'فهرست خالی است.',
    WorkshopPreRegistrationRegisteredSuccessfully:
      'درخواست پیش ثبت‌نام شما با موفقیت ثبت شد.',
    MustCompleteSurveyToReceiveWorkshopContents:
      'برای دریافت فایل‌های کارگاه ابتدا باید نظرسنجی مرتبط با دوره را تکمیل نمایید.',
    FeedbackSubmittedSuccessfully:
      'با سپاس از شما؛ پیام شما دریافت شد و به زودی توسط کارشناسان افرا مورد بررسی قرار خواهد گرفت.',
    ShareYourFeedbacksByFillingOutTheFormBelow:
      'شما می‌توانید با پر کردن فرم زیر، پیشنهادها و انتقادهای خود از بخش‌های مختلف را با ما مطرح نمایید.',
  };
}
